import { gql } from 'graphql-request';
import { GlobalQuery } from '@orgnc/core/lib/themes/queries';
import { IAimGeneralOptionsQuery } from '@orgnc/core/generated/graphql-operations';
import postFragment from '@orgnc/core/lib/wordpress/api/fragments/postFragment';
import mediaFragment from '@orgnc/core/lib/wordpress/api/fragments/mediaFragment';

const headerCardFragment = gql`
  fragment HeaderCardFragment on GeneralOptionsCardsHeaderCards {
    layout
    side
    titleGroup {
      text
      link
    }
    subtitleGroup {
      text
      link
    }
    imageGroup {
      image {
        node {
          ...MediaFragment
        }
      }
      link
    }
  }
  ${mediaFragment}
`;

export const query = gql`
  query AimGeneralOptionsQuery {
    flexpressCMSSettings {
      generalOptions {
        cards {
          showHeaderCards
          headerCards {
            ...HeaderCardFragment
          }
        }
        aimGeneralOptions {
          buyingGuideSpotlightPost {
            nodes {
              ...PostFragment
            }
          }
        }
      }
    }
  }
  ${postFragment}
  ${headerCardFragment}
`;

const aimGeneralOptionsQuery: GlobalQuery<IAimGeneralOptionsQuery> = {
  name: 'AimGeneralOptionsQuery',
  query,
};

export default aimGeneralOptionsQuery;
